import { createSlice, createAction } from '@reduxjs/toolkit';
import purge from 'store/purge';

const initialState = {
  stripeAddons: undefined,
  isLoading: false,
  error: undefined,
};

export default createSlice({
  name: 'STRIPE_ADDONS',
  initialState,
  reducers: {
    fetching: (state) => {
      state.isLoading = true;
      state.error = undefined;
    },

    error: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },

    success: (state) => {
      state.isLoading = false;
    },

    setStripeAddons: (state, { payload }) => {
      state.stripeAddons = payload;
    },
  },
  extraReducers: {
    ...purge(initialState),
  },
});

export const FETCH_STRIPE_ADDONS = createAction('FETCH_STRIPE_ADDONS');
